import { ReactNode } from "react";
import { Flex, Select, Text, InfoTooltip } from "src/elements";

interface Props<T> {
  title: string;
  options: Array<{ label: string; value: T; isDisabled?: boolean }>;
  value: T;
  setValue: (value: T) => void;
  isDisabled?: boolean;
  tooltip?: string | ReactNode;
}

export const RuleSelect = <T,>({
  title,
  options,
  value,
  setValue,
  isDisabled,
  tooltip,
}: Props<T>) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px">
      <Flex gap="5px" align="center" justify="center">
        <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
          {title}
        </Text>
        {tooltip && <InfoTooltip tooltip={tooltip} />}
      </Flex>

      <Flex width="fit-content" margin="0 auto">
        <Select
          width="max-content"
          options={options}
          value={value}
          setValue={setValue}
          isDisabled={isDisabled}
        />
      </Flex>
    </Flex>
  );
};
